module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-license/new-license.component.css
// module id = ./src/app/new-license/new-license.component.css
// module chunks = main